export { formatBRL } from '@garlic/shared';

const dt = new Intl.DateTimeFormat('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
const d = new Intl.DateTimeFormat('pt-BR', { dateStyle: 'medium' });

export function formatDateTime(value: string | Date, timeZone?: string) {
  const date = typeof value === 'string' ? new Date(value) : value;
  return timeZone ? new Intl.DateTimeFormat('pt-BR', { dateStyle: 'short', timeStyle: 'short', timeZone }).format(date) : dt.format(date);
}

export function formatDate(value: string | Date) {
  return d.format(typeof value === 'string' ? new Date(value) : value);
}

export function relativeTime(value: string | Date) {
  const diff = (Date.now() - new Date(value).getTime()) / 1000;
  const rtf = new Intl.RelativeTimeFormat('pt-BR', { numeric: 'auto' });
  if (diff < 60) return 'agora';
  if (diff < 3600) return rtf.format(-Math.round(diff / 60), 'minute');
  if (diff < 86400) return rtf.format(-Math.round(diff / 3600), 'hour');
  return rtf.format(-Math.round(diff / 86400), 'day');
}

/** Descrições legíveis das ações de auditoria. */
export const AUDIT_LABEL: Record<string, string> = {
  'platform.login': 'Login no painel DEV',
  'platform.login.failed': 'Tentativa de login DEV recusada',
  'platform.logout': 'Logout do painel DEV',
  'platform.mfa.enrolled': 'MFA configurado',
  'platform.admin.created': 'Administrador DEV criado',
  'platform.admin.password_reset': 'Senha de administrador DEV redefinida',
  'platform.restaurant.created': 'Restaurante cadastrado',
  'platform.restaurant.updated': 'Dados do restaurante alterados',
  'platform.restaurant.viewed': 'Consulta administrativa (painel DEV)',
  'platform.restaurant.status_changed': 'Status alterado',
  'platform.restaurant.slug_changed': 'Endereço (slug) alterado',
  'platform.restaurant.logo_changed': 'Logotipo alterado',
  'platform.subscription.updated': 'Plano alterado',
  'platform.invite.resent': 'Convite reenviado',
  'platform.staff.login_unlocked': 'Login liberado pelo Garlic (tentativas erradas)',
  'staff.login': 'Login de funcionário',
  'staff.login.failed': 'Tentativa de login recusada',
  'staff.invite.accepted': 'Convite aceito',
  'staff.password_reset.requested': 'Redefinição de senha solicitada',
  'staff.password_reset.completed': 'Senha redefinida',
  'staff.invited': 'Funcionário convidado',
  'staff.role_changed': 'Função alterada',
  'staff.blocked': 'Acesso bloqueado',
  'staff.unblocked': 'Acesso desbloqueado',
  'staff.removed': 'Removido da equipe',
  'role.created': 'Função criada',
  'role.permissions_changed': 'Permissões de função alteradas',
  'order.created': 'Pedido criado',
  'order.item_cancelled': 'Item cancelado',
  'session.opened': 'Comanda aberta',
  'session.closed': 'Comanda encerrada',
  'session.closed_with_balance': 'Comanda encerrada com saldo (exceção)',
  'session.bill_requested': 'Cliente pediu a conta',
  'menu.product.price_changed': 'Preço alterado',
  'menu.product.updated': 'Produto alterado',
  'menu.product.created': 'Produto criado',
  'payment.confirmed': 'Pagamento digital confirmado',
  'payment.manual_registered': 'Pagamento presencial registrado',
  'payment.manual_reversed': 'Registro manual estornado',
  'payment.reversed': 'Pagamento estornado (Mercado Pago)',
  'payment.overpaid': 'Recebido acima do devido',
  'account.discount_applied': 'Desconto aplicado',
  'payments.mp_connected': 'Mercado Pago conectado',
  'payments.mp_disconnected': 'Mercado Pago desconectado',
  'exit.receipt_issued': 'Comprovante de saída emitido',
  'exit.validated': 'Saída validada',
  'report.exported': 'Relatório exportado',
  'ticket.reprinted': 'Comanda reimpressa',
};
